module.exports = __webpack_public_path__ + "img/heart.9c16bad6.svg";